import { z } from 'zod'

export const paymentMethodSchema = z.object({
  id: z.string(),
  brand: z.string(),
  last4: z.string(),
  expMonth: z.number().int(),
  expYear: z.number().int(),
})

export type PaymentMethod = z.output<typeof paymentMethodSchema>

export const memberPaymentMethodSchema = paymentMethodSchema.extend({ isDefault: z.boolean() })

export type MemberPaymentMethod = z.output<typeof memberPaymentMethodSchema>

const CARD_BRANDS: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'Amex',
  discover: 'Discover',
}

export function formatCardBrand({ brand }: Pick<PaymentMethod, 'brand'>): string {
  return CARD_BRANDS[brand] ?? brand.charAt(0).toUpperCase() + brand.slice(1)
}

export function formatCardNumber({ last4 }: Pick<PaymentMethod, 'last4'>): string {
  return `•••• ${last4}`
}
